import { render, staticRenderFns } from "./PhoneBind.vue?vue&type=template&id=2d8291f6&scoped=true"
import script from "./PhoneBind.vue?vue&type=script&lang=ts"
export * from "./PhoneBind.vue?vue&type=script&lang=ts"
import style0 from "./PhoneBind.vue?vue&type=style&index=0&id=2d8291f6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d8291f6",
  null
  
)

export default component.exports